import { useToastStore } from '@/features/toasts/stores/useToastStore';
import { useBackendApi } from '@/services/useBackendApi';
import { useMutation, useQuery, useQueryCache, type UseMutationOptions } from '@pinia/colada';


export interface IUserDto {
    dailyGift: {
        lastClaim: string
    }
    id: number
    allows_write_to_pm: boolean
    coins: number
    first_name: string
    language_code: string
    last_name: string
    photo_url: string
    registredAt: string
    username: string
    referrals: [number?, number?, number?]
    referralsEarn: [number?, number?, number?]
    tasksCompleted: number
    tasksEarn: number
}

export function useUser() {
    const Api = useBackendApi();

    return useQuery({
        key: () => ['user'],
        query: () => Api.get<IUserDto>('/earn/user'),
    });
}